// Wordmark + marks for ShipOMS.in — colors match the brand logo. PNGs are transparent.
export function Wordmark({ className = "", light = false }) {
  return (
    <span className={`font-display font-extrabold ${className}`}>
      <span className={light ? "text-white" : "text-foreground"}>Ship</span>
      <span className="text-brand-red">OMS</span>
      <span className="text-orange-500">.in</span>
    </span>
  );
}

// Square box-only mark (transparent background). ?v bust caches so devices fetch the padded mark.
export function LogoMark({ className = "h-9 w-9" }) {
  return <img src="/shipoms-mark.png?v=4" alt="ShipOMS.in" className={`${className} max-w-none object-contain drop-shadow-[0_6px_14px_rgba(15,23,42,0.25)]`} />;
}

// Full lockup: box + wordmark + tagline (transparent background).
export function FullLogo({ className = "h-24" }) {
  return <img src="/shipoms-logo.png?v=3" alt="ShipOMS.in — Every order, under control" className={`${className} w-auto object-contain`} />;
}
